export default "__VITE_ASSET__7071bbb6__"